import React, { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import SearchCustomer from './SearchCustomer';
import CustomContainer from '../../components/CustomContainer';
import CustomerFormConfig from './CustomerFormConfig';
import { Actions } from '../../../client/Actions';
import CardForm from '../../components/form/CardForm';
import SearchCustomerFormConfig from './SearchCustomerFormConfig';
import FunctionalTableComponent from '../../components/table/FunctionalTableComponent';
import columns from '../reservation/list/ReservationTableConfig';
import IconButton from '../../components/button/IconButton';
import CustomerVerticalFormConfig from './CustomerVerticalFormConfig';

const CustomerReservationsPage = () => {
  const navigate = useNavigate();
  let { customerId } = useParams();

  const [customer, setCustomer] = useState();
  const [reservations, setReservations] = useState();

  function loadCustomer() {
    Actions.get('customer/' + customerId, setCustomer);
  }

  function loadReservations() {
    Actions.get('reservation/customer/' + customerId, setReservations);
  }

  useEffect(() => {
    loadCustomer();
    loadReservations();
  }, [customerId]);

  if (!customer || !reservations) {
    return <></>;
  }

  return (
    <>
      <CustomContainer title={'Rezerwacje klienta'}>
        <CardForm
          title={"Klient"}
          shadow={false}
          width={4}
          noActions={true}
          initialData={customer}
          readOnly={true}
          fields={CustomerVerticalFormConfig}
        />
        <FunctionalTableComponent
          shadow={false}
          title={'Lista rezerwacji'}
          columns={columns}
          header={true}
          initialData={reservations}
          removable={false}
          editable={false}
          additionalButtons={function (row) {
            return (
              <IconButton
                variant={'outline-primary'}
                onClick={() => {
                  navigate('/reservation/' + row.id);
                }}
                size={'sm'}
                className={'px-3'}
                tooltip={'Szczegóły'}
                icon={'fa-arrow-right '}
              />
            );
          }}
          width={8}
        />
      </CustomContainer>
    </>
  );
};

export default CustomerReservationsPage;
